export const SET_BINGO_SCHEDULE = 'SET_BINGO_SCHEDULE';

export const setBingoSchedule = payload => ({
    type: SET_BINGO_SCHEDULE,
    payload
});
